import VideoCarouselSlider from './VideoCarouselSlider';

export default async function VideoCarousel({ block, position }) {
  const entry = block?.video_carousel?.reference?.[0];
  if (!entry) return null;

  const { uid, heading, subheading, videos } = entry;

  return (
    <div
      id={`${uid}_${position}`}
      className="py-20 sm:px-20 sm:py-15 lg:px-30 lg:py-20"
      data-name="video-carousel"
    >
      <div className="lg:max-w-container mx-auto">
        {heading && (
          <div className="h3 lg:h2 mb-2.5 px-4 text-center text-balance">
            {heading}
          </div>
        )}
        {subheading && (
          <div className="body-r lg:body-l px-4 text-center text-balance">
            {subheading}
          </div>
        )}
        <VideoCarouselSlider
          heading={heading}
          subheading={subheading}
          videos={videos}
        />
      </div>
    </div>
  );
}
